import { Shimmer, ShimmerElementType } from "@fluentui/react";
import * as React from "react";
import { getAddTaskShimmerStyles, getClassNames, getColumnHeaderShimmerStyles, getStyles, getTaskCardShimmerStyles } from "./TaskBoardViewPlaceHolder.styles";
const taskCardPlaceHolderHeight = 108; // Default height for task card
const addTaskCardPlaceHolderHeight = 40; // Height for add task card
/**
 * TaskCardShimmer component to show a shimmer effect for a task card.
 */ function TaskCardShimmer(props) {
    const { taskCardHeight, taskCardShimmerStyles } = props;
    return /*#__PURE__*/ React.createElement(Shimmer, {
        shimmerElements: [
            {
                type: ShimmerElementType.line,
                height: taskCardHeight
            }
        ],
        styles: taskCardShimmerStyles
    });
}
/**
 * TaskBoardColumnShimmer component to show a shimmer effect for a task board column.
 */ function TaskBoardColumnShimmer(props) {
    const { numberOfTasks, showAddTaskButtonShimmer, classNames } = props;
    const shimmers = [];
    // creating taskCardshimmer elements with the count parameter to show the number of TaskCards in the column
    for(let i = 0; i < numberOfTasks; i += 1){
        shimmers.push(/*#__PURE__*/ React.createElement(TaskCardShimmer, {
            taskCardHeight: taskCardPlaceHolderHeight,
            taskCardShimmerStyles: getTaskCardShimmerStyles()
        }));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.containerShimmer
    }, /*#__PURE__*/ React.createElement(Shimmer, {
        shimmerElements: [
            {
                type: ShimmerElementType.line
            }
        ],
        styles: getColumnHeaderShimmerStyles
    }), showAddTaskButtonShimmer && /*#__PURE__*/ React.createElement(Shimmer, {
        shimmerElements: [
            {
                type: ShimmerElementType.line,
                height: addTaskCardPlaceHolderHeight
            }
        ],
        styles: getAddTaskShimmerStyles
    }), shimmers);
}
/**
 * TaskBoardViewPlaceHolder component to show a placeholder for the task board view.
 */ export function TaskBoardViewPlaceHolder(props) {
    const { showAddTaskButtonShimmer, numberOfTaskCardsPerColumn, stylesOverride } = props;
    const classNames = getClassNames(getStyles(stylesOverride));
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.root
    }, numberOfTaskCardsPerColumn?.map((count, index)=>/*#__PURE__*/ React.createElement(TaskBoardColumnShimmer, {
            key: index,
            numberOfTasks: count,
            showAddTaskButtonShimmer: showAddTaskButtonShimmer,
            classNames: classNames
        })));
}
